import PopeyeModal from '../popeye-modal.class'

export class ZayModal extends PopeyeModal {
  modal = {
    template: require('./zay.modal.html'),
    /** @ngInject */
    controller: function (
      $scope,
      item,
      ourFirms,
      legacyUsers,
      managers,
      contracts,
      inner,
      parentData,
      selected
    ) {
      $scope.vm = this
      this.item = item
      this.ourFirms = ourFirms
      this.legacyUsers = legacyUsers
      this.managers = managers
      this.contracts = contracts
      this.mode = 'modal'
      this.inner = inner
      this.parentData = parentData
      this.selected = selected
    },
  }
}
